export const setAuthToken = (token) => {
  if (token) {
    // Set the token as a cookie. You might want to set an expiration date.
    document.cookie = `auth_token=${token}; path=/; secure; samesite=strict`;
  } else {
    // Remove the token cookie
    document.cookie = 'auth_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  }
};

export const getAuthToken = () => {
  const name = "auth_token=";
  const decodedCookie = document.cookie;
  const ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

export const isAuthenticated = () => {
    console.log('isAuthenticated')
  const token = getAuthToken();
  return token !== "";
};

export const removeAuthToken = () => {
  document.cookie = 'auth_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
}; 